import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth, formatApiErrorDetail } from "../context/AuthContext";
import { Loader2 } from "lucide-react";
import { toast } from "sonner";

export default function Register() {
  const { registerUser } = useAuth();
  const navigate = useNavigate();
  const [form, setForm] = useState({ name: "", email: "", phone: "", password: "" });
  const [loading, setLoading] = useState(false);
  const set = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await registerUser(form);
      toast.success("Account created");
      navigate("/dashboard");
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail) || "Registration failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <main className="min-h-screen flex items-center justify-center relative z-10 px-6 pt-28 pb-16">
      <div className="w-full max-w-md">
        <p className="overline text-[#9A7420] mb-3 text-center">Join Women Heaven</p>
        <h1 className="font-display text-5xl tracking-tight text-center mb-10">Create account</h1>
        <form data-testid="register-form" onSubmit={submit} className="space-y-7">
          <div>
            <label className="overline block mb-2">Full Name</label>
            <input data-testid="register-name" required className="input-line" value={form.name} onChange={set("name")} />
          </div>
          <div>
            <label className="overline block mb-2">Email</label>
            <input data-testid="register-email" type="email" required className="input-line" value={form.email} onChange={set("email")} />
          </div>
          <div>
            <label className="overline block mb-2">Phone</label>
            <input data-testid="register-phone" className="input-line" value={form.phone} onChange={set("phone")} />
          </div>
          <div>
            <label className="overline block mb-2">Password</label>
            <input data-testid="register-password" type="password" required minLength={6} className="input-line" value={form.password} onChange={set("password")} />
          </div>
          <button data-testid="register-submit" type="submit" disabled={loading} className="btn-primary w-full justify-center">
            {loading ? <Loader2 className="w-4 h-4 animate-spin" /> : "Create Account"}
          </button>
        </form>
        <p className="text-center text-[#57515F] mt-8">
          Already a member?{" "}
          <Link to="/login" data-testid="go-login" className="text-[#9A7420] underline">Sign in</Link>
        </p>
      </div>
    </main>
  );
}
